import { useLazyQuery, useMutation } from '@apollo/client';
import { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  Col,
  Collapse,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from 'reactstrap';
import CustomButton from '../../../../components/layout/CustomButton';
import { customSelectStyleNew } from '../../../../components/styled/customSelect';
import { AppContext } from '../../../../context';
import {
  COMPANY_DETAILS_ROUTE,
  CONTACT_DETAIL_ROUTE,
  PLACEMENT_CANCELLED,
  PLACEMENT_ENDED,
  VIEW_ACCOUNTING_DASHBOARD_ROUTE,
  VIEW_JOB_ORDER_ROUTE,
  VIEW_PLACEMENT_MANAGEMENT_ROUTE,
  workplaceTypes,
  WorkType,
} from '../../../../utils/constant';
import { pushInHistory } from '../../../../utils/helper';
import { IComingState } from '../../../agreements/interfaces';
import {
  GET_JOB_ORDER_DETAIL_LIGHT,
  UPDATE_JOB_ORDER_OF_PLACEMENT,
} from '../gql';
import CreateContact from './CreateContact';

const JobOrderWidgetDetail = ({
  fromWhichPlacement,
  placement,
  candidateId,
  jobApplicantId,
  id,
  pipeCompanyIdToParent,
  placementAccountsStatus,
  from,
  widgetPermissions,
  watch: watcher,
  accountManager,
  placementStatus,
  refetchPlacement,
  ...props
}: any) => {
  const { theme } = useContext(AppContext);
  const history = useHistory();
  const location = useLocation<IComingState>();
  const [titleMsg, setTitleMsg] = useState<any>({
    msg: 'You can enter up to 55 characters',
    charLength: 0,
  });
  const [companyId, setCompanyId] = useState(null);
  const [addressList, setAddressList] = useState<Array<any>>([]);
  const [contactsLists, setContactList] = useState<Array<any>>([]);
  const [customEmailInputs, setCustomEmailInputs] = useState<any>([
    {
      email: '',
      isPrimary: true,
    },
  ]);
  const [modal, setModal] = useState(false);
  const [newContactFieldsModal, setNewContactFieldsModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [getJobOrder, { data }] = useLazyQuery(GET_JOB_ORDER_DETAIL_LIGHT);
  const [updateJobOrder, { loading }] = useMutation(
    UPDATE_JOB_ORDER_OF_PLACEMENT
  );
  const backURL = location.pathname.includes(VIEW_ACCOUNTING_DASHBOARD_ROUTE)
    ? `${VIEW_ACCOUNTING_DASHBOARD_ROUTE}/${placement?.id}`
    : `${VIEW_PLACEMENT_MANAGEMENT_ROUTE}/${placement?.id}`;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    control,
    watch,
    reset,
  } = useForm();
  const { jobCCContactIds } = watch();

  useEffect(() => {
    if (id) {
      getJobOrder({ variables: { id } });
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (data?.getJobOrder?.company?.id) {
      if (from === 'create') {
        pipeCompanyIdToParent(data?.getJobOrder?.company?.id);
      }
    }
    // eslint-disable-next-line
  }, [data?.getJobOrder?.company?.id]);
  const onCancel = () => {
    setNewContactFieldsModal(false);
    toggle();
    setCustomEmailInputs([
      {
        email: '',
        isPrimary: true,
      },
    ]);
  };
  const updatePlacementJobOrder = async (values) => {
    const jobLocationValue = values?.jobLocation?.value;
    const jobCCContactIds = Array.isArray(values?.jobCCContactIds)
      ? values.jobCCContactIds.map((obj) => (typeof obj === 'object' && obj?.value ? obj.value : obj))
      : [];

    const cleanedPayload = {
      placementId: placement?.id,
      jobOrderId: id,
      updateForJobOrder: !!values?.updateForJobOrder,
      jobTitle: values?.jobTitle,
      jobAllowRemote: values?.jobAllowRemote === 'true',
      jobMainContactId: values?.jobMainContactId?.value ?? values?.jobMainContactId,
      jobBillingContactId: values?.jobBillingContactId?.value ?? values?.jobBillingContactId,
      jobReportToContactId: values?.jobReportToContactId?.value ?? values?.jobReportToContactId,
      jobCCContactIds,
      jobWorkType: values?.jobWorkType?.value ?? values?.jobWorkType,
      jobworkplaceTypes: values?.workplaceTypes?.value ?? values?.workplaceTypes ?? values?.jobworkplaceTypes,
      jobCity: jobLocationValue?.jobCity,
      jobCountryCode: jobLocationValue?.jobCountryCode,
      jobStateCode: jobLocationValue?.jobStateCode,
      jobPostalCode: jobLocationValue?.jobPostalCode,
      jobCompanyLocationId: jobLocationValue?.jobCompanyLocationId,
      jobStreet: jobLocationValue?.jobStreet,
      jobDivision: jobLocationValue?.jobDivision,
      jobOwnerId: values?.jobOwnerId?.value ?? values?.jobOwnerId,
    };

    let res = await updateJobOrder({
      variables: {
        jobOrderInput: cleanedPayload,
      },
    });
    if (res?.data?.updatePlacementJobOrderInfo?.status === 200) {
      toast.success('Successfully Update!');
      refetchPlacement();
      toggle();
    }
  };

  // this method is used for finding all the contacts of job order still exist again the company or not
  useEffect(() => {
    if (data?.getJobOrder) {
      createContactAndAddressOptions(data?.getJobOrder?.company);

      const contacts = placement?.placementContacts ?? [];
      let mainContact = contacts.find((c) => c.contactType === 'MAIN')?.companyContact?.id;
      let billingContact = contacts.find((c) => c.contactType === 'BILLING')?.companyContact?.id;
      let remoteContact = contacts.find((c) => c.contactType === 'REPORT_TO')?.companyContact?.id;
      let ccContacts = contacts
        .filter((c) => c.contactType === 'CC_INVOICE_TO')
        .map((c) => c.companyContact?.id);
      let allContacts = [
        mainContact,
        remoteContact,
        billingContact,
        ...(ccContacts ?? []),
      ];
      let companyContacts = data?.getJobOrder?.company?.companyContacts?.map(
        (item) => item.id
      );

      let existingContacts: any = [];
      for (let contact of allContacts) {
        if (!companyContacts.includes(contact)) {
          existingContacts.push(contact);
        }
      }
      if (existingContacts.length && props?.contactChangeHandler) {
        props?.contactChangeHandler(existingContacts[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.getJobOrder]);

  const onclickModal = () => {
    setNewContactFieldsModal(!newContactFieldsModal);
    if (customEmailInputs?.length === 0) {
      setCustomEmailInputs([
        {
          email: '',
          isPrimary: true,
        },
      ]);
    }
  };
  // this function is used for making contacts options and address option on the behalf of the job order company
  const createContactAndAddressOptions = (companySelected) => {
    setCompanyId(companySelected?.id);

    if (companySelected && companySelected?.address?.length) {
      let addressList = companySelected?.address?.map((v: any) => ({
        label: ['US', null, undefined, ''].includes(v?.country)
          ? `${v?.division ? `${v?.division}, ` : ''}${v?.streetAddress}, ${v?.city}, ${v?.state}, ${v?.zipCode}, ${v?.country}`
          : `${v?.division ? `${v?.division}, ` : ''}${v?.streetAddress}, ${v?.city}, ${v?.zipCode}, ${v?.country}`,
        value: {
          jobDivision: v?.division,
          jobCity: v?.city,
          jobStateCode: v?.state,
          jobStreet: v?.streetAddress,
          jobCountryCode: v?.country,
          jobPostalCode: v?.zipCode,
          jobCompanyLocationId: v.id,
        },
      }));

      addressList.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      setAddressList(addressList);
    } else {
      // If we select a company with an address and after that select another company with no address then the other company can use the address of the previously selected company
      setAddressList([]);
    }
    if (companySelected && companySelected?.companyContacts?.length) {
      let contactsList = companySelected?.companyContacts?.filter((v: any) => v?.status === 'ACTIVE')?.map((v: any) => ({
        label: v.fullName,
        value: v.id,
      }));
      contactsList.sort((a, b) => {
        const labelA = a.label.toUpperCase(); // ignore upper and lowercase
        const labelB = b.label.toUpperCase(); // ignore upper and lowercase
        if (labelA < labelB) {
          return -1;
        }
        if (labelA > labelB) {
          return 1;
        }
        // labels must be equal
        return 0;
      });

      setContactList(contactsList);
    } else {
      // If we select a company with some contact and after that select another company with no contact then the other company can use the contacts of the previously selected company
      setContactList([]);
    }
  };

  // in this useEffect we are prefill the job order data which is saved in the placement
  useEffect(() => {
    if (modal) {

      if (!!placement && !!data?.getJobOrder) {
        const contacts = placement?.placementContacts ?? [];
        let mainContact = contacts.find((c) => c.contactType === 'MAIN')?.companyContact;
        let billingContact = contacts.find((c) => c.contactType === 'BILLING')?.companyContact;
        let remoteContact = contacts.find((c) => c.contactType === 'REPORT_TO')?.companyContact;
        let ccContacts = contacts
          .filter((c) => c.contactType === 'CC_INVOICE_TO')
          .map((c) => c.companyContact);
        let ccContactObj = ccContacts.length
          ? ccContacts?.map((ccContacts) => {
            return {
              label: ccContacts?.fullName,
              value: ccContacts?.id,
            };
          })
          : null;
        let jobAllowRemote = `${placement?.jobAllowRemote}`;
        let workplaceType = workplaceTypes?.find(
          (item) => item?.label === placement?.jobworkplaceTypes
        );
        let jobLocation = {
          label: ['US', null, undefined, ''].includes(placement?.jobCountryCode)
            ? `${placement?.jobStreet}, ${placement?.jobCity}, ${placement?.jobStateCode}, ${placement?.jobPostalCode}, ${placement?.jobCountryCode}${placement?.jobDivision ? `, ${placement?.jobDivision}` : ''}`
            : `${placement?.jobStreet}, ${placement?.jobCity}, ${placement?.jobPostalCode}, ${placement?.jobCountryCode}${placement?.jobDivision ? `, ${placement?.jobDivision}` : ''}`,
          value: {
            jobCity: placement?.jobCity,
            jobStateCode: placement?.jobStateCode,
            jobStreet: placement?.jobStreet,
            jobCountryCode: placement?.jobCountryCode,
            jobPostalCode: placement?.jobPostalCode,
            jobCompanyLocationId: placement?.jobCompanyLocationId,
            jobDivision: placement?.jobDivision,
          },
        };
        let myJobWorkType
        if (placement?.jobWorkType) {
          myJobWorkType = WorkType?.find(
            (item) => {
              return (item?.label).toLowerCase() ===
                (placement?.jobWorkType).toLowerCase()
            }
          );
        }
        reset({
          ...placement,
          updateForJobOrder: false,
          jobAllowRemote,
          jobLocation,
          jobOwnerId: placement?.jobOwnerId ?? placement?.jobOwner?.id ?? placement?.jobOrder?.jobOwner?.id ?? data?.getJobOrder?.jobOwner?.id,
          jobMainContactId: mainContact
            ? { label: mainContact?.fullName, value: mainContact?.id }
            : null,
          jobBillingContactId: billingContact
            ? {
              label: billingContact?.fullName,
              value: billingContact?.id,
            }
            : null,
          jobReportToContactId: remoteContact
            ? {
              label: remoteContact?.fullName,
              value: remoteContact?.id,
            }
            : null,
          jobCCContactIds: ccContactObj ?? null,
          jobWorkType: myJobWorkType ?? null,
          workplaceTypes: workplaceType ?? null,
        });
      }

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placement, data?.getJobOrder, modal]);

  const customStyles = {
    control: (styles, provided) => ({
      ...styles,

      fontSize: 12,
    }),

    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
    }),

    container: (provided, state) => ({
      ...provided,
      fontSize: 12,
    }),
  };

  useEffect(() => {
    if (!jobCCContactIds || jobCCContactIds.length === 0) {
      setValue('jobCCContactIds', []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h5 className="m-0">Job Info</h5>
        {placementAccountsStatus && placementStatus !== PLACEMENT_ENDED && placementStatus !== PLACEMENT_CANCELLED ? (
          <button
            type="button"
            onClick={toggle}
            disabled={widgetPermissions}
            className="buttonGenericStyle outlinedButtonDark"
          >
            Edit
          </button>
        ) : null}
      </div>

      <div>
        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Company Name</label>

          {!!placement?.companyName ? (
            <h6
              className="anchorColorText route-link"
              onClick={() => {
                history.push({
                  pathname: `${COMPANY_DETAILS_ROUTE}/${placement?.jobOrderOfPlacement?.company?.id}`,
                  state: {
                    backUrl: backURL,
                    searchParameters: location.search,
                  },
                });

                pushInHistory(backURL);
              }}
            >
              {placement?.companyName}
            </h6>
          ) : (
            <h6>--</h6>
          )}
        </div>

        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Job Title</label>
          {!!placement?.jobTitle ? (
            <h6
              className="anchorColorText route-link"
              onClick={() => {
                history.push({
                  pathname: `${VIEW_JOB_ORDER_ROUTE}/${placement?.jobOrderOfPlacement?.id}`,
                  state: {
                    backUrl: backURL,
                    searchParameters: location.search,
                  },
                });

                pushInHistory(backURL);
              }}
            >
              {placement?.jobTitle}
            </h6>
          ) : (
            '--'
          )}
        </div>
        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Job Location</label>
          <h6>
            {['US', null, undefined, ''].includes(placement?.jobCountryCode)
              ? `${placement?.jobDivision ? `${placement?.jobDivision}, ` : ''}${placement?.jobStreet || '--'}, ${placement?.jobCity || '--'
              }, ${placement?.jobStateCode || '--'}, ${placement?.jobPostalCode || '--'
              }`
              : `${placement?.jobDivision ? `${placement?.jobDivision}, ` : ''}${placement?.jobStreet || '--'}, ${placement?.jobCity || '--'
              }, ${placement?.jobPostalCode || '--'}, ${placement?.jobCountryCode || '--'}`}
          </h6>
        </div>

        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Workplace Type</label>
          <h6>{placement?.jobworkplaceTypes}</h6>
        </div>

        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Main Contact</label>

          {!!placement?.placementContacts?.length ? (
            <h6
              className="route-link"
              onClick={() => {
                history.push({
                  pathname: `${CONTACT_DETAIL_ROUTE}/${placement?.placementContacts?.find((c) => c.contactType === 'MAIN')?.companyContact?.id}`,
                  state: {
                    backUrl: backURL,
                    searchParameters: location.search,
                  },
                });

                pushInHistory(backURL);
              }}
            >
              {placement?.placementContacts.find(({ contactType }) => contactType === "MAIN")?.companyContact?.fullName}
            </h6>
          ) : (
            <h6>--</h6>
          )}
        </div>

        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Billing Contact</label>

          {!!placement?.placementContacts?.length ? (
            <h6
              className="route-link"
              onClick={() => {
                history.push({
                  pathname: `${CONTACT_DETAIL_ROUTE}/${placement?.placementContacts?.find((c) => c.contactType === 'BILLING')?.companyContact?.id}`,
                  state: {
                    backUrl: backURL,
                    searchParameters: location.search,
                  },
                });

                pushInHistory(backURL);
              }}
            >
              {placement?.placementContacts.find(({ contactType }) => contactType === "BILLING")?.companyContact?.fullName ||
                '--'}
            </h6>
          ) : (
            <h6>--</h6>
          )}
        </div>

        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Report To Contact</label>

          {!!placement?.placementContacts?.length ? (
            <h6
              className="route-link"
              onClick={() => {
                history.push({
                  pathname: `${CONTACT_DETAIL_ROUTE}/${placement?.placementContacts?.find((c) => c.contactType === 'REPORT_TO')?.companyContact?.id}`,
                  state: {
                    backUrl: backURL,
                    searchParameters: location.search,
                  },
                });
                pushInHistory(backURL);
              }}
            >
              {placement?.placementContacts.find(({ contactType }) => contactType === "REPORT_TO")?.companyContact?.fullName ||
                '--'}
            </h6>
          ) : (
            <h6>--</h6>
          )}
        </div>

        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>CC Invoice To</label>
          {placement?.placementContacts?.filter((c) => c.contactType === 'CC_INVOICE_TO').length ? (
            <div className="contact-list-ul">
              {placement.placementContacts.filter((c) => c.contactType === 'CC_INVOICE_TO').map((contact, index) => {
                const ccContacts = placement.placementContacts.filter((c) => c.contactType === 'CC_INVOICE_TO');
                const isLastContact = index === ccContacts.length - 1;
                return (
                  <p
                    key={contact.companyContact?.id}
                    className="route-link contact-list-li"
                    onClick={() => {
                      history.push({
                        pathname: `${CONTACT_DETAIL_ROUTE}/${contact?.companyContact?.id}`,
                        state: {
                          backUrl: backURL,
                          searchParameters: location.search,
                        },
                      });
                      pushInHistory(backURL);
                    }}
                  >
                    {contact.companyContact?.fullName || '--'}
                    {isLastContact ? '' : ', '}
                  </p>
                );
              })}
            </div>
          ) : (
            <h6>--</h6>
          )}
        </div>

        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Work Type</label>
          <h6>{placement?.jobWorkType || '--'}</h6>
        </div>

        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Company Owner</label>
          <h6>{accountManager || '--'}</h6>
        </div>

        <div className="d-flex justify-content-between mb-2 contentGridLabel">
          <label>Job Owner</label>
          <h6>{props?.jobOwner || '--'}</h6>
        </div>
      </div>

      <Modal
        isOpen={modal}
        toggle={toggle}
        className="revampDialog revampDialogWidth"
      >
        <div className="d-flex justify-content-between px-4 py-3">
          <h5>Update Placement Job</h5>
          <div>
            <div className="d-flex align-items-center">
              <h6 className="mr-2 my-auto switchLabel1">Update For Job</h6>
              <label className="switch m-0">
                <Controller
                  name="updateForJobOrder"
                  control={control}
                  defaultValue={false}
                  render={({ field }) => (
                    <Input
                      type="checkbox"
                      checked={field.value === true}
                      onChange={(e) => field.onChange(e.target.checked)}
                      onBlur={field.onBlur}
                      innerRef={field.ref}
                    />
                  )}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>

        <Form>
          <ModalBody>
            <Row>
              <Col>
                <Label>
                  Job Title <span className="text-danger">*</span>
                </Label>
                <Controller
                  name="jobTitle"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: 'Job title is required!',
                    },
                  }}
                  render={({ field }) => (
                    <Input
                      placeholder="job Title"
                      {...field}
                      value={field.value ?? ""}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value?.length === 0) {
                          setTitleMsg({
                            msg: 'You can enter up to 55 characters',
                            charLength: value?.length,
                          });
                        }
                        if (value?.length > 0) {
                          setTitleMsg({
                            msg: `Current length: ${value?.length}`,
                            charLength: value?.length,
                          });
                        }
                        field.onChange(e);
                      }}
                    />
                  )}
                />
                <div className="titile-count-message mt-1 d-flex flex-column">
                  <small className="text-danger">
                    {errors?.jobTitle?.message as any}
                  </small>

                  <small
                    className={`${titleMsg?.charLength > 55
                      ? 'text-danger'
                      : 'titile-count-message-color'
                      } `}
                  >
                    {titleMsg?.msg}
                  </small>
                </div>
              </Col>

              <Col>
                <FormGroup>
                  <Label>
                    Workplace Type
                    {watch('status')?.value === 'ACTIVE' && (
                      <span className="text-danger">*</span>
                    )}
                  </Label>
                  <Controller
                    name="workplaceTypes"
                    control={control}
                    rules={{
                      required: {
                        value:
                          watch('status')?.value === 'ACTIVE' ? true : false,
                        message: 'Must Select Workplace Types!',
                      },
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={workplaceTypes}
                        placeholder="Select Workplace Type"
                        styles={{ ...customSelectStyleNew(theme) }}
                      />
                    )}
                  />

                  <small className="text-danger">
                    {errors?.workplaceTypes?.message as any}
                  </small>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>
                    Main contact <span className="text-danger">*</span>
                  </Label>

                  <Controller
                    name="jobMainContactId"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: 'Must Select Main Contact!',
                      },
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isDisabled={companyId ? false : true}
                        options={contactsLists}
                        placeholder="Main Contact"
                        isSearchable={true}
                        styles={{ ...customSelectStyleNew(theme) }}
                      />
                    )}
                  />

                  <small className="text-danger">
                    {errors?.jobMainContactId?.message as any}
                  </small>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>
                    Report to Contact <span className="text-danger">*</span>
                  </Label>

                  <Controller
                    name="jobReportToContactId"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: 'Must Select Report to Contact!',
                      },
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isDisabled={companyId ? false : true}
                        options={contactsLists}
                        placeholder="Report to Contact"
                        isSearchable={true}
                        styles={{ ...customSelectStyleNew(theme) }}
                      />
                    )}
                  />

                  <small className="text-danger">
                    {errors?.jobReportToContactId?.message as any}
                  </small>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <FormGroup>
                  <Label>
                    Billing Contact <span className="text-danger">*</span>
                  </Label>

                  <Controller
                    name="jobBillingContactId"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: 'Must Select Billing Contact!',
                      },
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isDisabled={companyId ? false : true}
                        options={contactsLists}
                        placeholder="Billing Contact"
                        styles={{ ...customSelectStyleNew(theme) }}
                      />
                    )}
                  />

                  <small className="text-danger">
                    {errors?.jobBillingContactId?.message as any}
                  </small>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>CC Invoice To</Label>

                  <Controller
                    name="jobCCContactIds"
                    control={control}
                    rules={{
                      required: {
                        value: false,
                        message: 'Must Select  CC Invoice To!',
                      },
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isDisabled={companyId ? false : true}
                        options={contactsLists}
                        placeholder="CC Invoice To"
                        isMulti
                        styles={{ ...customSelectStyleNew(theme) }}
                      />
                    )}
                  />

                  <small className="text-danger">
                    {errors?.jobCCContactIds?.message as any}
                  </small>
                </FormGroup>
                <div className="d-flex align-items-start">
                  <button
                    type="button"
                    className="bg-transparent border-0 text-info px-0 pt-0 btn btn-secondary"
                    onClick={onclickModal}
                  >
                    Create new contact
                  </button>
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Collapse isOpen={newContactFieldsModal} border-0>
                  <div className="box-shadow mt-2 px-3 pt-1 pb-1">
                    <CreateContact
                      companyId={placement?.jobOrder?.company?.id}
                      setValue={setValue}
                      setContactList={setContactList}
                      contactList={contactsLists}
                      setNewContactFieldsModal={setNewContactFieldsModal}
                      setCustomEmailInputs={setCustomEmailInputs}
                      customEmailInputs={customEmailInputs}
                      jobCCContactIds={jobCCContactIds}
                    />
                  </div>
                </Collapse>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>
                    Actual Job Location <span className="text-danger">*</span>
                  </Label>

                  <Controller
                    name="jobLocation"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: 'Must Select Actual job location!',
                      },
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isDisabled={companyId ? false : true}
                        options={addressList}
                        placeholder="Actual job location"
                        isSearchable={true}
                        styles={{ ...customSelectStyleNew(theme) }}
                      />
                    )}
                  />

                  <small className="text-danger">
                    {errors?.jobLocation?.message as any}
                  </small>
                </FormGroup>
              </Col>

              <Col>
                <FormGroup>
                  <Label>
                    Work Type
                    {watch('status')?.value === 'ACTIVE' && (
                      <span className="text-danger">*</span>
                    )}
                  </Label>

                  <Controller
                    name="jobWorkType"
                    control={control}
                    rules={{
                      required: {
                        value:
                          watch('status')?.value === 'ACTIVE' ? true : false,
                        message: 'Must Select workType!',
                      },
                    }}
                    defaultValue={{
                      label: 'Direct Hire',
                      value: 'direct hire',
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={WorkType}
                        placeholder="Work Type"
                        styles={{ ...customSelectStyleNew(theme) }}
                      />
                    )}
                  />

                  <small className="text-danger">
                    {errors?.jobWorkType?.message as any}
                  </small>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>

          <ModalFooter>
            <button
              type="button"
              onClick={onCancel}
              className="buttonPrimary mr-3"
            >
              Cancel
            </button>
            <CustomButton
              buttonText="Update"
              buttonColor="primary"
              buttonType="submit"
              className="big-width"
              buttonClick={handleSubmit(updatePlacementJobOrder)}
              loading={loading}
              disabled={loading}
            />
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default JobOrderWidgetDetail;
